import {
  createContext,
  useState,
  FunctionComponent,
  useContext,
  useCallback,
} from 'react'
import { getCache, removeCache, setCache } from '@/utils/cache'
import { GeneralThemeAndControls, IThemeGeneratorContext } from '../types'
import { defaultThemeCnx } from '../constants'

const RebrandingThemeGeneratorContext =
  createContext<IThemeGeneratorContext>(null)

export const RebrandingThemeGeneratorProvider: FunctionComponent = ({
  children,
}) => {
  const [theme, setTheme] = useState<GeneralThemeAndControls>(() => {
    const theme = getCache<GeneralThemeAndControls>('rebrandingColors')
    if (theme) {
      return theme
    }

    return defaultThemeCnx
  })

  const setThemeColors = useCallback(
    (themeColors: GeneralThemeAndControls | null): void => {
      if (themeColors) {
        setTheme(themeColors)
        setCache('rebrandingColors', themeColors)
      } else {
        setTheme(defaultThemeCnx)
        removeCache('rebrandingColors')
      }
    },
    [],
  )

  return (
    <RebrandingThemeGeneratorContext.Provider
      value={{
        theme,
        setThemeColors,
      }}
    >
      {children}
    </RebrandingThemeGeneratorContext.Provider>
  )
}

export const useRebrandingThemeGeneratorContext =
  (): IThemeGeneratorContext => {
    const context = useContext(RebrandingThemeGeneratorContext)
    if (!context) {
      throw new Error(
        'useAuthContext must be used within a RebrandingThemeGeneratorProvider',
      )
    }
    return context
  }
